
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Visibility } from '../../rl-common/shared/shared/types/visibility.enum';
import { Annotation } from '../shared/annotation';
import { SearchParams } from './types';

@Injectable({
  providedIn: 'root'
})
export class AnnotationService {

  constructor(private http : HttpClient) { }
  
  load = (params : SearchParams) : Observable<Annotation[]> => this.http.get<Annotation[]>('../rl/ann/annotations', {params : params});

  save = (ann: Annotation) : Observable<Annotation> => this.http.post<Annotation>('../rl/ann/annotations', ann);

  delete = (annId : string) : Observable<void> => this.http.delete<void>('../rl/ann/annotations/' + annId);

  deleteAllComments = (params : SearchParams) : Observable<void> => this.http.delete<void>('../rl/ann/annotations/comments', {params : params});

  deleteAll = (ids: string[]) : Observable<void> => this.http.delete<void>('../rl/ann/annotations');

  updateComment = (annId: string, text : string, visibility : Visibility) : Observable<Annotation> => this.http.patch<Annotation>('../rl/ann/annotations/' + annId, {text : text, visibility : visibility});

  update = (ann: Annotation) : Observable<Annotation> => this.http.put<Annotation>('../rl/ann/annotations/' + ann.id, ann);

  enablePublicAnnotations = (citationId : string, enable : boolean) : Observable<void> => this.http.patch<void>(`../rl/main/citation/${citationId}/enablePublicAnnotations`, {enable : enable});

  reply = (annIdToReply : string, text : string) : Observable<any> => this.http.post<any>(`../rl/ann/annotations/${annIdToReply}/reply`, text, { headers: new HttpHeaders({
    'Content-Type': 'application/json',
  })
  });
}